import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Paper, Divider, Grid } from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";
import MapLegendBlock from "./MapLegendBlock";

const styles = (theme) => ({
  outerMostWrapper: {
    zIndex: 2,
    position: "absolute",
    pointerEvents: "auto",
    bottom: "4%",
    left: "5%",
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.ModalBGColor,
    width: "90%",
  },
  detailsContainer: {
    position: "absolute",
    top: "10%",
    left: "12%",
  },
  legendHeader: {
    color: theme.HeaderSelectedText,
    fontSize: "14px",
    height: 25,
    padding: 10,
    fontWeight: 600,
    textAlign: "left",
    display: "flex",
    alignItems: "center",
  },
  legendDetailsContainer: {
    display: "flex",
    justifyContent: "flex-start",
    padding: 1,
    width: "100%",
  },
  details: {
    display: "flex",
    alignItems: "center",
    columnGap: 5,
    padding: 10,
    width: "33.3%",
  },
  detailsLabel: {
    color: theme.ModalHeaderTextColor,
    fontSize: "11px",
    lineHeight: "15px",
    marginLeft: 5,
    marginRight: 5,
  },
  iconContainer: {
    width: 24,
    height: 24,
    marginLeft: -2,
  },
  pickupContainer: { paddingRight: "10px" },
  deliveryContainer: {
    width: 22,
    height: 22,
    backgroundColor: theme.HeaderSelectedText,
    borderRadius: 11,
  },
  divider: {
    background: theme.gridIconBorderColor,
    height: 0.5,
  },
  detailsHeader: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "19px",
  },
  iconStyle: {
    paddingLeft: "2%",
  },
});
class MapLegend extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
    };
  }
  toggleExpand = () => {
    this.setState((state) => ({
      isExpanded: !state.isExpanded,
    }));
  };
  render() {
    const { classes, theme, enableDriverActualRoute } = this.props;
    return (
      <Paper className={classes.outerMostWrapper}>
        {this.state.isExpanded ? (
          <div>
            <div className={classes.legendHeader}>
              Map Legend
              <ExpandMore onClick={this.toggleExpand} className={classes.iconStyle}></ExpandMore>
            </div>

            <Divider className={classes.divider} />
            <Grid container>
              <div className={classes.legendDetailsContainer}>
                <MapLegendBlock
                  classes={classes}
                  information="The stop seq suggested by RouteMAX so that driver can reach a stop in the shortest duration."
                  title="RouteMax Planned Stop Sequence"
                  markerName="PlannedRouteMarker"
                  color={theme.HeaderSelectedText}
                />
                <MapLegendBlock
                  classes={classes}
                  information="The sequence that the driver followed in reality."
                  title="Actual Stop Sequence"
                  markerName="ActualRouteMarker"
                  color={theme.deviationStopColor}
                />
                {enableDriverActualRoute? <MapLegendBlock
                  classes={classes}
                  information="The sequence that theThe route that the driver followed in reality."
                  title="Actual Route"
                  markerName="ActualRouteMarker"
                  color={theme.actualRouteColor}
                />:<div className={classes.details}></div>}
              </div>
            </Grid>
            <Grid container>
              <div className={classes.legendDetailsContainer}>
                <MapLegendBlock
                  classes={classes}
                  information="The stop that requires the driver to pick up shipments."
                  title="Pickups"
                  markerName="PickupMarker"
                />
                <MapLegendBlock
                  classes={classes}
                  information="The stop from where the driver deviated from the RouteMAX suggested route."
                  title="Route Deviation"
                  markerName="DeviationMarker"
                />
                <MapLegendBlock
                  classes={classes}
                  information="The stop that requires the driver to deliver shipments."
                  title="Deliveries"
                  markerName="DeliveriesMarker"
                />
              </div>
            </Grid>
          </div>
        ) : (
          <div>
            <div className={classes.legendHeader}>
              Map Legend
              <ExpandLess onClick={this.toggleExpand} className={classes.iconStyle}></ExpandLess>
            </div>
            <Divider className={classes.divider} />
          </div>
        )}
      </Paper>
    );
  }
}

export default withStyles(styles)(MapLegend);
